import { BlockHeading } from './BlockHeading';
import { Button } from './Button';
import FallBackImage from './FallBackImage';
import { Footer } from './Footer';
import { Header } from './Header';
import { Input } from './Input';
import { Loader } from './Loader';
import { Name } from './Name';
import { Price } from './Price';
import { Rating } from './Rating';
import { RatingStars } from './RatingStars';
import { Switch } from './Switch';

export const components = {
  Name,
  Header,
  Button,
  Input,
  Footer,
  Price,
  Loader,
  Rating,
  Switch,
  RatingStars,
  BlockHeading,
  FallBackImage,
};
